/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Karol Pawlak <karolpawlak.giap@gmail.com>, January 2020
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug/PowrotDoListyEuslug';
import { isMobileView, isTabletView, renderHelpDesc } from '../../components/utils/utils';
import EmptyFileDownloader from '../../components/EmptyFileDownloader/EmptyFileDownloader';
import { PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import { DecisionContainer } from '../../containers';
import _ from 'lodash';

import v from './validators';
import fetch from '../../core/fetch/fetch.server';


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const destinationOptions = [
  {
    label: 'uprawy rolne',
    value: 'uprawy rolne',
    state: 'destination',
  },
  {
    label: 'uprawy warzywno-ogrodnicze',
    value: 'uprawy warzywno-ogrodnicze',
    state: 'destination',
  },
  {
    label: 'zagospodarowanie drobną zielenią/zielenią izolacyjną',
    value: 'zagospodarowanie drobną zielenią/zielenią izolacyjną',
    state: 'destination',
  },
  {
    label: 'ogródek przydomowy',
    value: 'ogródek przydomowy',
    state: 'destination',
  },
];

const isPartOptions = [
  {
    label: 'TAK',
    value: 'nieruchomości',
    state: 'isPart',
  },
  {
    label: 'NIE',
    value: 'części nieruchomości',
    state: 'isPart',
  },
];

const parcelTypeOptions = [
  {
    label: 'zabudowana',
    value: 'zabudowanej',
    state: 'parcelType',
  },
  {
    label: 'niezabudowana',
    value: 'niezabudowanej',
    state: 'parcelType',
  },
];

const InfoTypeDict = {
  pesel: {
    label: 'PESEL/NIP:',
    editable: true,
  },
  dateStart: {
    label: 'Data rozpoczęcia dzierżawy (dd-mm-rrrr):',
    editable: true,
  },
  dateEnd: {
    label: 'Data zakończenia dzierżawy (dd-mm-rrrr):',
    editable: true,
  },
  destination: {
    label: 'Przeznaczenie nieruchomości:',
    editable: true,
  },
  reason: {
    label: 'Uzasadnienie:',
    editable: true,
    type: 'textarea',
  },
};

const InfoTypeDict2 = {
  isPart: {
    label: 'Czy część nieruchomości?',
    editable: false,
    type: 'Select',
    options: isPartOptions,
  },
  parcelType: {
    label: 'Rodzaj nieruchomości:',
    editable: false,
    type: 'Select',
    options: parcelTypeOptions,
  },
  town: {
    label: 'Miejscowość, w której znajduje się nieruchomość:',
    editable: true,
  },
  dateStart: {
    label: 'Data rozpoczęcia dzierżawy (dd-mm-rrrr):',
    editable: true,
  },
  dateEnd: {
    label: 'Data zakończenia dzierżawy (dd-mm-rrrr):',
    editable: true,
  },
  destination: {
    label: 'Przeznaczenie nieruchomości:',
    editable: true,
    type: 'Select',
    options: destinationOptions,
  },
};


class DzierzawaGruntowRolnych extends React.Component {
  state = {
    info: {
      pesel: null,
      dateStart: null,
      dateEnd: null,
      destination: null,
      reason: null,
      isPart: null,
      parcelType: null,
      town: null,
    },
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    selectedParcels: [],
    isMounted: false,
  };

  validators = {
    dateStart: [v.NotNull, v.CheckDate],
    dateEnd: [v.NotNull, v.CheckDate],
    isPart: [],
    parcelType: [],
    destination: [],
    town: [],
    pesel: [],
    reason: [],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        }, () => this.updateValidators());
      });

    this.setState({ isMounted: true });
  }

  updateValidators = () => {
    if (this.props.prefix === 'gmina_namyslow') {
      this.validators.isPart = [v.NotSelected];
      this.validators.parcelType = [v.NotSelected];
      this.validators.destination = [v.NotSelected];
      this.validators.town = [v.NotNull];
      this.validators.pesel = [];
      this.validators.reason = [];
    } else {
      this.validators.isPart = [];
      this.validators.parcelType = [];
      this.validators.destination = [v.NotNull];
      this.validators.town = [];
      this.validators.pesel = [v.NotNull, v.isInteger];
      this.validators.reason = [v.NotNull];
    }
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ['info'];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      info: {
        pesel: '123456789',
        dateStart: '12-10-2020',
        dateEnd: '12-02-2021',
        destination: 'ogródek warzywny',
        reason: 'Uzasadnienie testowe',
        isPart: 'nieruchomości',
        parcelType: 'zabudowanej',
        town: 'Warszawa',
      },
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
      });
      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });
      return;
    }
    if (!hasFieldErrors) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          dzialki: this.state.selectedParcels,
          selectedParcels: this.state.selectedParcels,
          info: this.state.info,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
        })
        .then(resp => {
          window.location.href = `${this.nextStep}${resp.jobId}`;
        });
    }
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user ? this.props.serviceInfo.user : null} />
        <GrayPanel
          title={'1. Adres'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        {this.props.prefix === 'gmina_namyslow' ?
          <DecisionContainer
            title={'2. Informacje'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={InfoTypeDict2}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          /> :
          <DecisionContainer
            title={'2. Informacje'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={InfoTypeDict}
            onChange={e => this.onChange(e, 'info')}
          />
        }
        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ progress: 0 }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

DzierzawaGruntowRolnych.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(DzierzawaGruntowRolnych),
);



// WEBPACK FOOTER //
// src/routes/eservices/DzierzawaGruntowRolnych.js